import React from 'react';
import PropTypes from 'prop-types';

// material-ui
import { Button, DialogContent, Stack, Typography } from '@mui/material';

// project import
import Avatar from 'components/@extended/Avatar';

// assets
import { InfoCircleFilled } from '@ant-design/icons';

// ==============================|| CONFIRM ACTION - MODAL ||============================== //

export default function ConfirmActionModal({
    title,
    body,
    onClose,
    onConfirm,
    confirmButtonLabel = 'Confirm',
    cancelButtonLabel = 'Cancel'
}) {
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        onClose();
    };

    return (
        <DialogContent sx={{ mt: 2, my: 1 }}>
            <Stack alignItems="center" spacing={3.5}>
                <Avatar color="info" sx={{ width: 72, height: 72, fontSize: '1.75rem' }}>
                    <InfoCircleFilled />
                </Avatar>
                <Stack spacing={2}>
                    <Typography variant="h4" align="center">
                        {title}
                    </Typography>
                    <Typography align="center">
                        {`Are you sure you want to `}
                        <Typography variant="subtitle1" component="span">
                            {` ${body}`}
                        </Typography>
                        {`? You can undo this action later if needed.`}
                    </Typography>
                </Stack>

                <Stack direction="row" spacing={2} sx={{ width: 1 }}>
                    <Button
                        fullWidth
                        onClick={onClose}
                        color="secondary"
                        variant="outlined"
                    >
                        {cancelButtonLabel}
                    </Button>
                    <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        onClick={handleConfirm}
                        autoFocus
                    >
                        {confirmButtonLabel}
                    </Button>
                </Stack>
            </Stack>
        </DialogContent>
    );
}

ConfirmActionModal.propTypes = {
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    confirmButtonLabel: PropTypes.string,
    cancelButtonLabel: PropTypes.string
};
